import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import { Link as GatsbyLink } from 'gatsby';

import styles from '../Button/Button.module.scss';
import { BRAND } from '../../constants/brand';

interface LinkProps {
  className?: string;
  containerClassName?: string;
  to: string;
  label?: string;
  external?: boolean;
  noStyles?: boolean;
  title?: string;
  onClick?: any;
}

const Link: FunctionComponent<LinkProps> = ({
  children,
  className,
  containerClassName,
  label,
  external = false,
  noStyles = false,
  to,
  onClick,
  ...props
}) => {
  const linkClass = classNames(`${BRAND.SUPER_SHORT_NAME}-link`, className, {
    [styles.button]: !noStyles,
    [styles.reset]: true,
  });

  const containerClass = classNames(containerClassName, {
    [styles.container]: label,
    [styles.flexContainer]: !label,
  });

  return (
    <div className={containerClass}>
      {!external && (
        <GatsbyLink onClick={onClick} className={linkClass} to={to} {...props}>
          {children}
        </GatsbyLink>
      )}
      {external && (
        <a onClick={onClick} className={linkClass} href={to} {...props}>
          {children}
        </a>
      )}
      {label && (
        <p className={styles.label}>
          <span>{label}</span>
        </p>
      )}
    </div>
  );
};

export default Link;
